export default __webpack_public_path__ + "static/media/dsv-ups-dom.41a8e61b.svg";